import * as ActionTypes from "constants/ActionTypes";

// Get all system models
export const adminGetSystemModels = (includeInactive = false) => ({
    type: ActionTypes.ADMIN_GET_SYSTEM_MODELS_START,
    includeInactive
});

export const adminGetSystemModelsSuccess = (data) => ({
    type: ActionTypes.ADMIN_GET_SYSTEM_MODELS_SUCCESS,
    payload: data

});

export const adminGetSystemModelsFailure = (error) => ({
    type: ActionTypes.ADMIN_GET_SYSTEM_MODELS_FAILURE,
    error
});

// Create system model
export const adminCreateSystemModel = (formData, callback) => ({
    type: ActionTypes.ADMIN_CREATE_SYSTEM_MODEL_START,
    formData,
    callback
});

export const adminCreateSystemModelSuccess = (data) => ({
    type: ActionTypes.ADMIN_CREATE_SYSTEM_MODEL_SUCCESS,
    payload: data
});

export const adminCreateSystemModelFailure = (error) => ({
    type: ActionTypes.ADMIN_CREATE_SYSTEM_MODEL_FAILURE,
    error
});

// Update system model
export const adminUpdateSystemModel = (modelId, data, callback) => ({
    type: ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_START,
    modelId,
    data,
    callback
});

export const adminUpdateSystemModelSuccess = (data) => ({
    type: ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_SUCCESS,
    payload: data
});

export const adminUpdateSystemModelFailure = (error) => ({
    type: ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_FAILURE,
    error
});

// Update system model image
export const adminUpdateSystemModelImage = (modelId, formData, callback) => ({
    type: ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_IMAGE_START,
    modelId,
    formData,
    callback
});

export const adminUpdateSystemModelImageSuccess = (data) => ({
    type: ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_IMAGE_SUCCESS,
    payload: data
});

export const adminUpdateSystemModelImageFailure = (error) => ({
    type: ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_IMAGE_FAILURE,
    error
});

// Update system model thumbnail only (existing image → crop → upload)
export const adminUpdateSystemModelThumbnail = (modelId, formData, callback) => ({
    type: ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_THUMBNAIL_START,
    modelId,
    formData,
    callback
});

export const adminUpdateSystemModelThumbnailSuccess = (data) => ({
    type: ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_THUMBNAIL_SUCCESS,
    payload: data
});

export const adminUpdateSystemModelThumbnailFailure = (error) => ({
    type: ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_THUMBNAIL_FAILURE,
    error
});

// Delete system model
export const adminDeleteSystemModel = (modelId, callback) => ({
    type: ActionTypes.ADMIN_DELETE_SYSTEM_MODEL_START,
    modelId,
    callback
});

export const adminDeleteSystemModelSuccess = (modelId) => ({
    type: ActionTypes.ADMIN_DELETE_SYSTEM_MODEL_SUCCESS,
    modelId
});

export const adminDeleteSystemModelFailure = (error) => ({
    type: ActionTypes.ADMIN_DELETE_SYSTEM_MODEL_FAILURE,
    error
});

// Toggle system model active status
export const adminToggleSystemModelActive = (modelId, isActive, callback) => ({
    type: ActionTypes.ADMIN_TOGGLE_SYSTEM_MODEL_ACTIVE_START,
    modelId,
    isActive,
    callback
});

export const adminToggleSystemModelActiveSuccess = (modelId, isActive) => ({
    type: ActionTypes.ADMIN_TOGGLE_SYSTEM_MODEL_ACTIVE_SUCCESS,
    modelId,
    isActive
});

export const adminToggleSystemModelActiveFailure = (error) => ({
    type: ActionTypes.ADMIN_TOGGLE_SYSTEM_MODEL_ACTIVE_FAILURE,
    error
});
